import React from "react";
import PropTypes from "prop-types";
import NeoCard from "../../../../../components/Common/NeoCard";

const DetailOnboarding = ({ checklist, onToggleChecklist }) => {
    return (
        <NeoCard
            title="Checklist de Implantação e Configuração Inicial"
            subtitle="Acompanhe as etapas de onboarding do cliente. Marque os passos concluídos para atualizar o histórico."
            thinBorder={true}
            bodyClassName="p-4"
        >
            <div className="d-flex flex-column gap-2">
                {checklist.map((item) => (
                    <div 
                        key={item.id} 
                        className={`d-flex align-items-center justify-content-between p-3 border rounded-3 transition-all ${
                            item.checked ? "bg-success bg-opacity-10 border-success-subtle" : "bg-light border-light-subtle"
                        }`}
                        style={{ cursor: "pointer" }}
                        onClick={() => onToggleChecklist(item.id)}
                    >
                        <div className="d-flex align-items-center flex-grow-1">
                            <input
                                type="checkbox"
                                className="form-check-input me-3"
                                checked={item.checked}
                                onChange={(e) => {
                                    e.stopPropagation(); // Evita clique duplo
                                    onToggleChecklist(item.id);
                                }}
                                style={{ width: "18px", height: "18px", cursor: "pointer" }}
                            />
                            <label 
                                className="form-check-label fw-semibold text-dark m-0" 
                                style={{ cursor: "pointer", fontSize: "14px" }}
                                onClick={(e) => e.preventDefault()}
                            >
                                {item.label}
                            </label>
                        </div>
                        <span className={`badge ${item.checked ? "bg-success-subtle text-success" : "bg-secondary-subtle text-secondary"} px-2 py-1 font-size-11`}>
                             {item.checked ? "Concluído" : "Pendente"}
                        </span>
                    </div>
                ))}
            </div>
        </NeoCard>
    );
};

DetailOnboarding.propTypes = {
    checklist: PropTypes.array.isRequired,
    onToggleChecklist: PropTypes.func.isRequired
};

export default DetailOnboarding;
